import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from 'react';
const AuthContext = createContext(undefined);
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const login = async (email, password) => {
        try {
            setIsLoading(true);
            // Mock authentication - replace with actual API call
            if (email === 'admin@afsa.org' && password === 'admin123') {
                const mockUser = {
                    id: '1',
                    email: 'admin@afsa.org',
                    name: 'AFSA Administrator',
                    role: 'admin'
                };
                setUser(mockUser);
                localStorage.setItem('auth_token', 'mock_token_12345');
                localStorage.setItem('user', JSON.stringify(mockUser));
                return true;
            }
            return false;
        }
        catch (error) {
            console.error('Login error:', error);
            return false;
        }
        finally {
            setIsLoading(false);
        }
    };
    const logout = () => {
        setUser(null);
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
    };
    const checkAuthStatus = () => {
        const token = localStorage.getItem('auth_token');
        const storedUser = localStorage.getItem('user');
        if (token && storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);
                setUser(parsedUser);
            }
            catch (error) {
                console.error('Error parsing stored user:', error);
                logout();
            }
        }
        setIsLoading(false);
    };
    useEffect(() => {
        checkAuthStatus();
    }, []);
    const value = {
        user,
        isAuthenticated: !!user,
        isLoading,
        login,
        logout
    };
    return _jsx(AuthContext.Provider, { value: value, children: children });
};
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
